module.exports = __webpack_public_path__ + "static/media/pen.b2063481.svg";